import PropTypes from 'prop-types';
import { memo, useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { BillboardActions } from 'actions';
import PrimaryPanel from './PrimaryPanel';
import SecondaryPanel from './SecondaryPanel';
import './styles.scss';

const PanelAdmin = memo(({ model }) => {
    const { isSecondaryShown, secondaryType } = useSelector((state) => ({
        isSecondaryShown: state.billboard.detail.showSecondary,
        secondaryType: state.billboard.detail.secondaryType,
    }));
    const dispatch = useDispatch();

    const [mounted, setMounted] = useState({
        sent: false,
        opened: false,
        confirmed: false,
    });

    useEffect(() => {
        if (isSecondaryShown && secondaryType) {
            setMounted((prev) => ({ ...prev, [secondaryType]: true }));
        }
    }, [isSecondaryShown, secondaryType]);

    const openSecondary = useCallback(
        (type) => {
            dispatch(BillboardActions.showSecondary(type));
        },
        [dispatch],
    );

    const closeSecondary = useCallback(
        (type) => {
            if (!isSecondaryShown || secondaryType !== type) {
                setMounted((prev) => ({ ...prev, [type]: false }));
            }
        },
        [isSecondaryShown, secondaryType],
    );

    return (
        <div className="billboard-panel-admin">
            <PrimaryPanel model={model} openSecondary={openSecondary} />
            {mounted.sent && (
                <SecondaryPanel
                    model={model}
                    titleLiteral={'label_billboard_sent'}
                    type={'sent'}
                    hasTabs={false}
                    open={isSecondaryShown && secondaryType === 'sent'}
                    transitionEnd={closeSecondary}
                />
            )}
            {mounted.opened && (
                <SecondaryPanel
                    model={model}
                    titleLiteral={'label_billboard_opened'}
                    type={'opened'}
                    hasTabs={true}
                    open={isSecondaryShown && secondaryType === 'opened'}
                    transitionEnd={closeSecondary}
                />
            )}
            {mounted.confirmed && (
                <SecondaryPanel
                    model={model}
                    titleLiteral={'label_billboard_confirmed'}
                    type={'confirmed'}
                    hasTabs={true}
                    open={isSecondaryShown && secondaryType === 'confirmed'}
                    transitionEnd={closeSecondary}
                />
            )}
        </div>
    );
});

PanelAdmin.propTypes = {
    model: PropTypes.object.isRequired,
};

export default PanelAdmin;
